import React, { PropsWithChildren, ComponentProps, forwardRef } from 'react';
import { type VariantProps } from 'class-variance-authority';

import getCtaStyles from '../button/get-cta-styles';

export interface AnchorLinkProps extends ComponentProps<'a'>, VariantProps<typeof getCtaStyles> {
	icon?: React.ReactNode;
	iconPosition?: 'start' | 'end';
	isLoading?: boolean;
}

const AnchorLink = forwardRef<HTMLAnchorElement, PropsWithChildren<AnchorLinkProps>>(
	(
		{
			href,
			icon,
			iconPosition = 'end',
			isLoading = false,
			className,
			intent = 'text',
			size,
			inverse,
			children,
			...props
		},
		ref
	) => {
		const hasIcon = Boolean(icon);

		const classNames = getCtaStyles({
			intent,
			isLoading,
			size,
			hasIcon,
			iconPosition,
			inverse,
			className,
		});

		return (
			<a ref={ref} href={href} className={classNames} {...props}>
				{children}
				{icon}
			</a>
		);
	}
);

AnchorLink.displayName = 'AnchorLink';

export default AnchorLink;
